<template>
    <b-overlay :show="getting" rounded opacity="1" class="pt-1">
        <!-- <div class="border rounded mx-1 p-1">
            <label class="form-label">Kim Onayladı?</label>
            <div class="d-flex g-1">
                <div class="w-100">
                    <v-select-list v-model="approver" label="Value" :options="approvers" v-on:search="searchEmployees" placeholder="Kim Onayladı?" :loading="employeeLoading"></v-select-list>
                </div>
                <v-executer :loading="savingApprove" :action="saveApprove">Kaydet</v-executer>
            </div>
        </div> -->
        <div class="mt-1 mx-1" v-if="this.icra>0 || this.avansUyari">
            <div class="alert alert-secondary mb-0">
                <div class="alert-body pr-75">
                    <div class="d-flex align-items-center" v-if="this.icra>0">
                        <b>İcra tutarı: </b> &nbsp; {{ this.icra }}₺
                        <span v-if="this.icraDurumu" class="ml-auto text-warning">{{ this.icraDurumu }}</span>
                    </div>
                    <div v-if="this.avansUyari" class="text-danger" :class="{'mt-50': this.icra>0}">
                        <feather-icon icon="AlertTriangleIcon" size="14"></feather-icon> {{ this.avansUyari }}
                    </div>
                </div>
            </div>
        </div>
        <div class="p-1" v-if="!file || forceUpload">
            <b-modal id="add-bordro" title="Ekle" no-close-on-esc no-close-on-backdrop>
                <employee-hakedis-upload-bordro v-model="value" :months="months" :bordro-list="bordroList"/>
                <template #modal-footer><v-executer :action="add" :disabled="!canAdd">Ekle</v-executer></template>
            </b-modal>
    
            <div class="border rounded mb-1">
                <div class="p-1 d-flex justify-content-between align-items-center">
                    <button v-on:click="createNew" class="btn btn-icon rounded-circle btn-primary">
                        <feather-icon icon="PlusIcon"></feather-icon>
                    </button>
                    <h3 class="mb-0">Bordrolar</h3>
                </div>
                <div class="table-responsive">
                    <table class="table table-sm bordered-header mb-0">
                        <thead>
                            <tr>
                                <th>
                                    <feather-icon icon="MoreHorizontalIcon"></feather-icon>
                                </th>
                                <th class="w-33">Bordro Türü</th>
                                <th class="w-33">Ay</th>
                                <th class="w-33">Yıl</th>
                                <th>Kesinti</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(v,i) in values" :key="i">
                                <td>
                                    <div class="d-flex">
                                        <button class="btn btn-flat-danger btn-sm btn-icon" v-on:click="$delete(values,i)">
                                            <feather-icon icon="TrashIcon"></feather-icon>
                                        </button>
                                    </div>
                                </td>
                                <td>{{ getType(v.Type) }}</td>
                                <td>{{ getMonth(v.Month) }}</td>
                                <td>{{ v.Year }}</td>
                                <td class="text-center">
                                    <span class="material-icons-outlined text-success" v-if="v.Kesinti">check_circle</span>
                                    <span class="material-icons-outlined text-danger" v-else>cancel</span>
                                </td>
                            </tr>
                            <tr v-if="values.length ==0">
                                <td colspan="1000" class="text-center">Henüz bir veri bulunmamaktadır.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="text-right">
                <button class="btn btn-outline-secondary mr-1" v-on:click="$emit('prev-step')">Geri</button>
                <v-executer :loading="saving" :action="send" variant="danger" :disabled="(values || []).length == 0">Dosyaları Kaydet ve Excel Oluştur</v-executer>
                <button v-if="file" class="btn btn-primary ml-1" v-on:click="forceUpload = false">Vazgeç</button>
            </div>
        </div>
        <div v-else class="p-1">
            <b-modal id="upload-hakedis" title="Düzenlenmiş Hakediş Tablosunu Yükle" no-close-on-esc no-close-on-backdrop>
                <p class="mb-1">Sistemden indirdiğiniz hakediş tablosunu düzenleyip (.xlsx) buraya yükleyin. Değerler tablodaki hücrelerden (Hakediş ve kesinti sütunları) okunur; KALAN ve TOPLAM otomatik hesaplanır. Lütfen satır/sütun yapısını bozmayın.</p>
                <v-file-uploader :accept="['xlsx']" :value="hakedisUpload" value-parameter="File"></v-file-uploader>
                <template #modal-footer><v-executer :action="sendHakedis" :loading="uploadingHakedis" :disabled="!hakedisUpload.File">Yükle</v-executer></template>
            </b-modal>
            <div class="alert alert-success mb-0">
                <div class="alert-body d-flex align-items-center g-75">
                    <span class="material-icons-outlined">done_all</span>
                    Bordro dosyaları yüklendi ve arabulucuk hakediş ön inceleme tablosu oluşturuldu.
                    <button class="btn btn-success btn-sm ml-auto" v-on:click="download">İndir</button>
                    <button class="btn btn-outline-primary btn-sm" v-on:click="openHakedisUpload">Düzenlenmiş Tabloyu Yükle</button>
                    <button class="btn btn-outline-warning btn-sm" v-on:click="recalculate">Yeniden Hesapla</button>
                    <button class="btn btn-outline-success btn-sm" v-on:click="forceUpload = true">Bordroları Yeniden Yükle</button>
                </div>
            </div>
            <!-- "Her şey dahil": 1. adımdan buraya taşındı. Seçim yapılmadan devam edilemez. -->
            <div class="border rounded p-1 mt-1">
                <label class="form-label">Her şey dahil <span class="text-danger">*</span></label>
                <select class="form-control" v-model="herSeyDahil" :disabled="savingHerSeyDahil" v-on:change="saveHerSeyDahil">
                    <option :value="null">Seçiniz</option>
                    <option :value="true">Evet</option>
                    <option :value="false">Hayır</option>
                </select>
                <small class="text-muted" v-if="herSeyDahil == null">Devam edebilmek için bu alanı seçmelisiniz.</small>
            </div>
            <div class="text-right mt-1">
                <button class="btn btn-outline-secondary mr-1" v-on:click="$emit('prev-step')">Geri</button>
                <button v-if="file" class="btn btn-primary" :disabled="herSeyDahil == null || savingHerSeyDahil" v-on:click="$emit('next-step')">Devam Et</button>
            </div>
        </div>
    </b-overlay>
</template>

<script>
import EmployeeHakedisUploadBordro from './EmployeeHakedisUploadBordro.vue'
import EmployeeOperationsApi from '@/api/employee-operations'
import { BOverlay } from 'bootstrap-vue'
import Additional from '@/utilities/additional'
import VFileUploader from '@/components/v-file-uploader/VFileUploader.vue'

export default {
    components:{
        EmployeeHakedisUploadBordro,
        BOverlay,
        VFileUploader
    },
    props:{
        id:[Number,String],
        taskId:[Number,String],
    },
    mounted(){
        this.get()
    },
    data(){
        return {
            types:[
                {name:'Ücret',value:0},
                {name:'Kıdem',value:1},
                {name:'İhbar',value:2},
            ],
            values:[],
            value:{
                Type:null,
                Month:null,
                Year:null,
                File:null,
                Kesinti:false
            },
            employee:null,
            approver:null,
            months:[
                {index:1,name:'Ocak'},
                {index:2,name:'Şubat'},
                {index:3,name:'Mart'},
                {index:4,name:'Nisan'},
                {index:5,name:'Mayıs'},
                {index:6,name:'Haziran'},
                {index:7,name:'Temmuz'},
                {index:8,name:'Ağustos'},
                {index:9,name:'Eylül'},
                {index:10,name:'Ekim'},
                {index:11,name:'Kasım'},
                {index:12,name:'Aralık'}
            ],
            saving:false,
            savingApprove:false,
            getting:false,
            file:null,
            forceUpload:false,
            hakedisUpload:{ File:null },
            uploadingHakedis:false,
            icra: 0,
            icraDurumu: '',
            avansUyari: '',
            // null = henüz seçilmedi -> "Devam Et" kapalı
            herSeyDahil:null,
            savingHerSeyDahil:false,
            employeeLoading:false,
            employees:[],
            approvers:[]
        }
    },
    methods:{
        clearForm(){
            this.value.Type = null
            this.value.Month = null
            this.value.Year = null
            this.value.File = null
            this.value.Kesinti = false
        },
        createNew(){
            this.clearForm()
            this.$showModal('add-bordro')
        },
        add(){
            this.values = [...this.values,structuredClone(this.value)]
            this.$hideModal('add-bordro')
        },
        getType(value){
            return this.types.find(s => s.value == value)?.name || 'Bilinmiyor'
        },
        getMonth(value){
            return this.months.find(m => m.index == value)?.name || 'Bilinmiyor'
        },
        send(){
            return new Promise((resolve) => {
                this.$confirm('Dosyaları Kaydet ve Excel Oluştur','Hakediş tablosu yalnızca bu oturumda verdiğiniz dökümanlarla oluşturulur. Bu ekrandan daha önce yüklenmiş dökümanlar varsa dikkate alınmaz. Devam edilsin mi?').then(c => {
                    if(!c){ resolve(); return }
                    const formData = new FormData();

                    (this.values || []).forEach((item, index) => {
                        item.Type != null && formData.append(`Bordros[${index}].Type`, item.Type.toString())
                        item.Month != null && formData.append(`Bordros[${index}].Month`, item.Month.toString())
                        item.Year != null && formData.append(`Bordros[${index}].Year`, item.Year.toString())
                        item.File != null && formData.append(`Bordros[${index}].File`, item.File)
                        item.Kesinti != null && formData.append(`Bordros[${index}].Kesinti`, item.Kesinti.toString())
                    })

                    formData.append('JobExitTaskId',this.taskId)
                    this.saving = true
                    EmployeeOperationsApi.jobExitUploadBordros(formData).then(res => {
                        if(res.data.Success){
                            this.get()
                        }
                        this.$result(res)
                        this.saving = false
                        resolve()
                    }).catch(err => {
                        this.$result(null,err)
                        this.saving = false
                        resolve()
                    })
                }).catch(()=>resolve())
            })
        },
        get(){
            this.getting = true
            EmployeeOperationsApi.ArabuluculukHakedisTablosuExcel(this.taskId).then(res => {
                this.getting = false
                if(res.data.Success){
                    this.file = res.data.Data.ExcelPath
                    this.icra = res.data.Data.Icra ?? 0
                    this.icraDurumu = res.data.Data.IcraDurumu || ''
                    this.avansUyari = res.data.Data.AvansUyari || ''
                    // false geçerli bir seçim: sadece undefined/null "seçilmedi" sayılır.
                    this.herSeyDahil = res.data.Data.HerSeyDahil ?? null
                    this.forceUpload = false
                    if(res.data.Data.Approver){
                            this.approver = res.data.Data.Approver
                    }
                }
                this.$result(res)
            }).catch(err => {
                this.getting = false
                this.$result(null,err)
            })
        },
        download(){
            Additional.DownloadTab(this.file)
        },
        // Bordroları yeniden yüklemeden tabloyu güncel bordro + KYKM verisinden yeniden üretir.
        // (Ör. hakediş tablosu oluşturulduktan sonra bir KYKM eklendiyse.)
        // Not: elle düzenlenip yüklenmiş tabloyu ezer, o yüzden onay istenir.
        recalculate(){
            this.$confirm('Yeniden Hesapla','Tablo güncel bordro ve KYKM verisinden yeniden hesaplanacak. Elle düzenleyip yüklediğiniz değerler varsa kaybolur. Devam edilsin mi?').then(c => {
                if(!c) return
                this.get()
            }).catch(()=>{})
        },
        openHakedisUpload(){
            this.hakedisUpload = { File:null }
            this.$showModal('upload-hakedis')
        },
        sendHakedis(){
            if(!this.hakedisUpload.File) return
            const formData = new FormData()
            formData.append('file', this.hakedisUpload.File)
            this.uploadingHakedis = true
            EmployeeOperationsApi.UploadHakedisTablosu(this.taskId, formData).then(res => {
                if(res.data.Success){
                    this.file = res.data.Data.ExcelPath
                    this.icra = res.data.Data.Icra ?? 0
                    this.icraDurumu = res.data.Data.IcraDurumu || ''
                    this.avansUyari = res.data.Data.AvansUyari || ''
                    this.herSeyDahil = res.data.Data.HerSeyDahil ?? null
                    this.$hideModal('upload-hakedis')
                }
                this.$result(res)
                this.uploadingHakedis = false
            }).catch(err => {
                this.$result(null,err)
                this.uploadingHakedis = false
            })
        },
        // Seçim anında kaydedilir; kaydedilemezse seçim geri alınır (ekranda DB'de olmayan bir değer kalmasın).
        saveHerSeyDahil(){
            if(this.herSeyDahil == null) return
            const secilen = this.herSeyDahil
            this.savingHerSeyDahil = true
            EmployeeOperationsApi.UpdateHerSeyDahilOfExitTask(this.taskId, secilen).then(res => {
                if(!res.data.Success) this.herSeyDahil = null
                this.$result(res)
                this.savingHerSeyDahil = false
            }).catch(err => {
                this.herSeyDahil = null
                this.$result(null,err)
                this.savingHerSeyDahil = false
            })
        },
        searchEmployees(searchKey){
            return new Promise((resolve)=>{
                if(searchKey){
                    const search = () => {
                        this.employeeLoading = true
                        clearTimeout(this.searchOnTableTimer)
                        this.searchOnTableTimer = setTimeout(()=>{ 
                            this.employeeLoading = true
                            EmployeeOperationsApi.Employee.GetApproversOfExit(searchKey).then((res) => {
                                this.employeeLoading = false
                                this.approvers = res.data.Data
                                resolve()
                            }).catch(err=> {
                                console.log(err)
                                this.employeeLoading = false
                            })
                        },500)
                    }
                    clearTimeout(this.searchOnTableTimer)
                    this.searchOnTableTimer = setTimeout(()=>{ search.call(this) },500)
                }
            })
        },
        saveApprove(){
            this.savingApprove = true
            if(this.approver && this.approver.Value)
            {
                EmployeeOperationsApi.UpdateApproverOfExitTask(this.taskId,this.approver.Value).then(res => {
                                this.$result(res)
                                this.savingApprove = false
                            }).catch(err => {
                                this.$result(null,err)
                                this.savingApprove = false
                            })
            }
            else
            {
                EmployeeOperationsApi.DeleteApproverOfExitTask(this.taskId).then(res => {
                this.$result(res)
                this.savingApprove = false
                            }).catch(err => {
                                this.$result(null,err)
                                this.savingApprove = false
                            })
            }
        }
    },
    computed:{
        bordroList(){
            // Kıdem(1)/İhbar(2): yalnızca birer tane. Ücret(0): en fazla 2 dönem (çıkış ayı + opsiyonel önceki ay).
            return this.types.filter(t => {
                const count = this.values.filter(v => v.Type == t.value).length
                if(t.value == 0) return count < 2
                return count < 1
            })
        },
        canAdd(){
            return this.value.Type != null && this.value.Month != null && this.value.Year != null && this.value.File != null
        }
    }
}
</script>